// React/Redux
import React from 'react';
import PropTypes from 'prop-types';
import config from 'config';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

// Components
import CatalogCards from '../cards/catalogCards';
import ContentArea from '../content-area/content-area';
import InlineEdit from 'components/SharedComponents/Inline/inline-edit';

// Actions
import * as contentsActions from '@getgo/webinar.com-frontend-redux/lib/shared/actions/contents';
import * as channelsActions from '@getgo/webinar.com-frontend-redux/lib/shared/actions/channel-profile';

// Helpers
import * as contentsHelper from 'app-lib/helpers/contents-helper';
import { dragulaDecorator } from 'app-lib/helpers/drag-and-drop-helper';
import * as groupsHelper from '../../../app-lib/helpers/groups-helper';
import * as mixpanelTracker from 'app-lib/mixpanel/mixpanelTracker';

export class GroupContent extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (!this.props.groupData.contentKeys || this.props.groupData.contentKeys.length === 0) {
            return;
        }
        const contentCount = 50;
        let startIndex = 0;
        let endIndex = contentCount;
        for (let pageNo = 0; pageNo < this.props.groupData.contentKeys.length / contentCount; pageNo++) {
            if (this.props.contents.error) {
                break;
            }
            const slicedContentKeys = this.props.groupData.contentKeys.slice(startIndex, endIndex);
            this.props.getGroupContents(slicedContentKeys, pageNo, this.props.isChannelOwner, this.props.numberOfGroups)
                .catch((error) => {
                    if (error.status === 401) {
                        return;
                    }
                    this.props.mountInternalErrorPage('Get Groups Content Failure', error);
                });
            startIndex = endIndex;
            endIndex = endIndex + contentCount;
        }
    }

    deleteThumbnail(id, e) {
        e.stopPropagation();
        this.props.deleteThumbnail(id);
    }

    checkDefaultGroup(groupKey) {
        const { channel } = this.props;
        return (channel && channel.defaultGroupKey === groupKey);
    }

    removeGroup() {
        const mixpanelAttributes = { groupKey: this.props.groupData.groupKey };
        mixpanelTracker.track(`${mixpanelTracker.channelPage}-${mixpanelTracker.groupDeleteBtnClicked}`, mixpanelAttributes);

        if (!this.props.groupData.contentKeys || this.props.groupData.contentKeys.length === 0) {
            this.props.deleteGroup(this.props.channelKey, this.props.groupData.groupKey);
            return;
        }
        this.props.moveContentsToAnotherGroup(this.props.channelKey, this.props.groupData.groupKey,
            this.props.channel.defaultGroupKey, this.props.groupData.contentKeys)
            .then(() => {
                this.props.deleteGroup(this.props.channelKey, this.props.groupData.groupKey);
            }).catch((error) => {
                this.props.dispatchDeleteDataError(error);
            });
    }

    handleMoveGroup(groupKey, moveType) {
        const groupKeysArray = [...this.props.channel.groupKeys];
        const mixpanelAttributes = { groupKey, moveType };
        let newGroupKeysArray = [];
        // moveType -1 to move group up and 1 to move group down
        newGroupKeysArray = groupsHelper.moveGroupKeyInArray(groupKeysArray, groupKey, moveType);
        mixpanelTracker.track(`${mixpanelTracker.channelPage}-${mixpanelTracker.groupMoveBtnClicked}`, mixpanelAttributes);
        this.props.putChannelMoveGroups(this.props.channelKey, newGroupKeysArray);
    }

    groupNameChanged(groupKey, id, groupName) {
        const mixpanelAttributes = { groupKey };
        mixpanelTracker.track(`${mixpanelTracker.channelPage}-${mixpanelTracker.groupNameChanged}`, mixpanelAttributes);
        this.props.putChannelGroup(this.props.channelKey, groupKey, groupName);
    }

    groupNameInlineEdit() {
        const {t, groupData} = this.props;
        if (this.checkDefaultGroup(groupData.groupKey)) {
            return null;
        }
        return (
            <span className="channel-group_title" >
                <InlineEdit
                  maxlength={50}
                  t={t}
                  editText={this.dataChanged.bind(this, groupData.groupKey)}
                  text={groupData && groupData.groupName ? groupData.groupName : ''}
                  id={groupData.groupKey}
                  characterCheckRequired={true}
                />
            </span>
        );
    }
    groupDeleteButton() {
        return (
            <div className="clearfix">
                <button type="button" className="empty-group-close close" aria-hidden="true" onClick={() => { this.removeGroup(); }}>
                    <i className="togo-icon togo-icon-closes"></i>
                </button>
            </div>
        );
    }

    dataChanged(groupKey, id, data) {
        this.groupNameChanged(groupKey, id, data);
    }

    renderEmptyGroupTemplate() {
        const {t, isChannelOwner, groupData} = this.props;
        if (isChannelOwner) {
            return (
                <div className="content-area-container">
                    <div className="empty-group-wrapper">
                        <div className="empty-group-headers">
                            {this.groupNameInlineEdit()}
                            {this.groupDeleteButton()}
                        </div>
                        <div className="empty-group-container">
                            <div className="empty-group_content">
                                <img className="drag-n-drop-icon" src={`${config.assets.url}/images/catalog/drag-n-drop-icon.png`} alt="" />
                                <p className="empty-group_para1">{t('groups.empty-group.para1')}</p>
                                <p className="empty-group_para2">
                                    <div>{t('groups.empty-group.para2a')}</div>
                                    <div>{t('groups.empty-group.para2b')}</div>
                                    <div>{t('groups.empty-group.para2c')}</div>
                                </p>
                            </div>
                            <div className="empty-group-dragula" id={groupData.groupKey} ref={dragulaDecorator.bind(this)} />
                        </div>
                    </div>
                </div>);
        }
        return null;
    }

    filterContents() {
        return contentsHelper.filterGroupContents(this.props.contents.data, this.props.groupData);
    }

    createCatalogCards(contents) {
        const catalogCards = contents.map((content) => {
            return (
                <div key={content.id} className="catalog-card-wrapper">
                    <CatalogCards
                      details={content}
                      t={this.props.t}
                      isChannelOwner={this.props.isChannelOwner}
                      isFeatured={this.props.isFeatured(content.id)}
                      editRecordingTitle={this.props.editRecordingTitle}
                      index={content.id}
                      deleteThumbnail={this.deleteThumbnail.bind(this)}
                      featuredClicked={this.props.featuredClicked}
                      thumbnailUploadClicked={this.props.thumbnailUploadClicked}
                      categoryChangeClicked={this.props.categoryChangeClicked}
                      params={this.props.channelKey}
                    />
                </div>
            );
        });
        return catalogCards;
    }

    hasPublicContent() {
        const groupContents = this.filterContents();
        return (groupContents && groupContents.length > 0);
    }

    renderContent() {
        return (
            <ContentArea
              key={this.props.groupData.groupKey}
              groupKey={this.props.groupData.groupKey}
              isChannelOwner={this.props.isChannelOwner}
              title={this.props.t(this.props.groupData.groupName)}
              details={this.createCatalogCards(this.filterContents())}
              dragulaInstance={this.props.dragulaInstance}
              groupNameChanged={this.groupNameChanged.bind(this)}
              isDefaultGroup={this.checkDefaultGroup(this.props.groupData.groupKey)}
              moveGroup={this.handleMoveGroup.bind(this)}
              allGroupKeys={(this.props.channel && this.props.channel.groupKeys) ? this.props.channel.groupKeys : []}
            />
        );
    }

    render() {
        if (this.checkDefaultGroup(this.props.groupData.groupKey) && !this.hasPublicContent()) {
            return null;
        }
        if (!this.hasPublicContent()) {
            return this.renderEmptyGroupTemplate();
        }
        return this.renderContent();
    }
}

GroupContent.propTypes = {
    t: PropTypes.func.isRequired,
    isChannelOwner: PropTypes.bool.isRequired,
    channel: PropTypes.object.isRequired,
    groupData: PropTypes.object.isRequired,
    channelKey: PropTypes.string.isRequired,
    deleteGroup: PropTypes.func.isRequired,
    putChannelGroup: PropTypes.func.isRequired,
    putChannelMoveGroups: PropTypes.func.isRequired,
    editRecordingTitle: PropTypes.func.isRequired,
    getGroupContents: PropTypes.func.isRequired,
    contents: PropTypes.array.isRequired,
    deleteThumbnail: PropTypes.func.isRequired,
    featuredClicked: PropTypes.func.isRequired,
    isFeatured: PropTypes.func.isRequired,
    thumbnailUploadClicked: PropTypes.func.isRequired,
    categoryChangeClicked: PropTypes.func.isRequired,
    numberOfGroups: PropTypes.number.isRequired,
    dragulaInstance: PropTypes.object,
    moveContentsToAnotherGroup: PropTypes.func.isRequired,
    dispatchDeleteDataError: PropTypes.func.isRequired,
    mountInternalErrorPage: PropTypes.func.isRequired

};


export default connect(
    state => ({
        getGroupContents: state.getGroupContents,
        contents: state.contents,
        channel: state.channel.channel
    }),
    dispatch => bindActionCreators(Object.assign({}, contentsActions, channelsActions), dispatch)
)(translate(['translation'])(GroupContent));



// WEBPACK FOOTER //
// ./src/components/catalog/group/group-content.js